import React from 'react';

type ReloadRoute = {
  params?: {
    reload?: boolean;
  };
};

type ReloadNavigation = {
  setParams: (params: { reload: undefined }) => void;
};

export function useExplorerMapDataRefreshKey({
  navigation,
  route,
}: {
  navigation: ReloadNavigation;
  route: ReloadRoute;
}) {
  const [mapDataRefreshKey, setMapDataRefreshKey] = React.useState(0);
  const reload = route.params?.reload;

  React.useEffect(() => {
    if (!reload) return;

    // Consumes an imperative route reload flag and exposes it as a stable scalar key.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMapDataRefreshKey((key) => key + 1);
    navigation.setParams({ reload: undefined });
  }, [navigation, reload]);

  return mapDataRefreshKey;
}
